import { useClient } from '../../api/api-client';
import { useQueryCall } from '../../api/react-client';
import { hasCookieToken } from '../../utils/CookieToken';

export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const SET_ROLES = 'SET_ROLES';

export const useGetRoles = (params) => (dispatch, getState) => {
  const client = useClient();

  return useQueryCall(
    {
      onSuccess: (res) => {
        if (res?.isError) {
          dispatch(setUserRoles(res));
          return;
        }
        dispatch(
          setUserRoles({
            current_role: res?.current_role,
            base_roles: res?.base_roles,
            add_on_roles: res?.add_on_roles,
            temporary_roles: res?.temporary_roles,
          }),
        );
      },
    },
    'permissions/role_switch',
    ['fetchingRoles'],
    () => client('permissions/role_switch'),
  );
};

export const setUserDetails = (userDetails) => ({
  type: SET_USER_DETAILS,
  userDetails,
});

export const setAuthentication = (isAuthenticated) => {
  isAuthenticated = isAuthenticated || hasCookieToken;
  return {
    type: SET_AUTHENTICATION,
    isAuthenticated,
  };
};

export const setUserRoles = (roleDetails) => {
  return {
    type: SET_ROLES,
    roleDetails,
  };
};
